import React from "react";
import styled from "styled-components";
import MessagePost from "./MessagePost";

const StyledDivContainer = styled.div``;

const StyledDivReplies = styled.div`
  margin-left: 3rem;
`;

export default function MessageThread({ message, replies }) {
  return (
    <StyledDivContainer>
      <MessagePost
        message={message}
        replyToMessageId={message.obj.id}
        isReply={true}
      />
      <StyledDivReplies>
        {replies.map((reply, i) => (
          <MessagePost
            key={i}
            message={reply}
            replyToMessageId={message.obj.id}
            isReply={true}
          />
        ))}
      </StyledDivReplies>
    </StyledDivContainer>
  );
}
